// extracted by mini-css-extract-plugin
module.exports = {"summary":"_3Pv1K-DrCvYtVLcwC-os_c"};